import React from 'react';
import * as Styles from '../../footer-pattern.styled';
import { Link } from '@at/design-system-elements';
export var FooterNavCompany = function (_a) {
    var trackingCallback = _a.trackingCallback;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles.FooterMetaInfo, { as: "section" },
            React.createElement("span", null,
                "Copyright \u00A9 Auto Trader Limited ",
                new Date().getFullYear(),
                "."),
            React.createElement("span", null,
                "Auto Trader Limited (trading as Autotrader) is authorised and regulated by the Financial Conduct Authority. Our FCA firm reference number is 735711. Our FCA authorisation includes credit broking and insurance introductions. We are not a lender.",
                ' ',
                React.createElement(Link, { routerLink: false, href: "https://help.autotrader.co.uk/hc/en-gb/articles/16865586061725-How-does-Autotrader-make-money-from-finance-and-insurance", trackingCallback: trackingCallback }, "Read more about our role and about fees and commissions"))),
        React.createElement(Styles.FooterMetaInfo, { as: "section" },
            React.createElement("span", null, "Registered office and headquarters"),
            React.createElement("address", null,
                "4th Floor ",
                React.createElement("br", null),
                "1 Tony Wilson Place",
                React.createElement("br", null),
                "Manchester",
                React.createElement("br", null),
                "M15 4FN",
                React.createElement("br", null),
                "United Kingdom",
                React.createElement("br", null),
                "Registered number: 03909628"))));
};
